'use client';

import { Slider as SliderPrimitive } from '@base-ui/react/slider';
import { cn } from '@savvy-kit/lib/utils';

function Slider({ className, defaultValue, value, min = 0, max = 100, ...props }: SliderPrimitive.Root.Props) {
  const toArray = (v: number | readonly number[] | undefined) =>
    v === undefined ? undefined : Array.isArray(v) ? [...v] : [v];
  const _values = toArray(value) ?? toArray(defaultValue) ?? [min, max];

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      thumbAlignment="edge"
      className={cn('data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full', className)}
      {...props}
    >
      <SliderPrimitive.Control className="relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col">
        <SliderPrimitive.Track
          data-slot="slider-track"
          className="bg-muted relative grow overflow-hidden rounded-full select-none data-[orientation=horizontal]:h-1 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1"
        >
          <SliderPrimitive.Indicator
            data-slot="slider-range"
            className="bg-primary select-none data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
          />
        </SliderPrimitive.Track>
        {Array.from({ length: _values.length }, (_, index) => (
          <SliderPrimitive.Thumb
            data-slot="slider-thumb"
            key={index}
            className="border-primary relative block size-3.5 shrink-0 rounded-full border bg-primary shadow-sm transition-[color,box-shadow] select-none after:absolute after:-inset-2 hover:cursor-pointer hover:bg-success-foreground-dark focus-visible:bg-success-foreground-dark focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
          />
        ))}
      </SliderPrimitive.Control>
    </SliderPrimitive.Root>
  );
}

export { Slider };
